/**
 * @generated SignedSource<<aed928c86f10a4e4f6955f6a921227cd>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceSmartCreationModalQuery$variables = Record<PropertyKey, never>;
export type ConfluenceSmartCreationModalQuery$data = {
  readonly user: {
    readonly id: string | null;
    readonly title: string | null;
  } | null;
};
export type ConfluenceSmartCreationModalQuery = {
  response: ConfluenceSmartCreationModalQuery$data;
  variables: ConfluenceSmartCreationModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCreationModalQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConfluenceSmartCreationModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e04a1fbd9772100897718d8eb52d327f",
    "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
    "metadata": {},
    "name": "ConfluenceSmartCreationModalQuery",
    "operationKind": "query",
    "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
  }
};
})();

(node as any).hash = "b82822dc05785ac3b5e50c2feec2f4f2";

export default node;
